<footer class="page-footer">
	<p>
		<span>&copy; ALLPLAN GmbH - </span>
		<span class="brand-group">Nemetschek Group</span>
	</p>
</footer>
